// @flow
export { default } from './LetterCard';



// WEBPACK FOOTER //
// ./src/components/common/LetterCard/index.js